import { WorkoutPlanCreatorV2 } from '@/features/workout-creator/ui/v2/workout-creator-v2';

function AboutPage() {
	return (
		<div>
			<WorkoutPlanCreatorV2 />
		</div>
	);
}

export { AboutPage };
